import { render, staticRenderFns } from "./Arquivos.vue?vue&type=template&id=151ea4a5&scoped=true&"
import script from "./Arquivos.vue?vue&type=script&lang=js&"
export * from "./Arquivos.vue?vue&type=script&lang=js&"
import style0 from "./Arquivos.vue?vue&type=style&index=0&id=151ea4a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ea4a5",
  null
  
)

export default component.exports